import { Ajax, Ajax2 } from '@shared/Ajax';
import { CanvasUtils } from '@shared/utils/CanvasUtils';

// IMPORTANT: we can't use svgs for icons in openlayers, they have big performance hit in chrome only, so we have to use pngs. research in the future if fixed
import iconAsphalt from '../../../assets/images/vehicle_icons/asphalt-paving-machine-active-opti.png';
import iconBackhoe from '../../../assets/images/vehicle_icons/backhoe-active-opti.png';
import iconBarge from '../../../assets/images/vehicle_icons/barge-active-opti.png';
import iconBasestation from '../../../assets/images/vehicle_icons/base-station-active-opti.png';
import iconBulldozer from '../../../assets/images/vehicle_icons/bulldozer-active-opti.png';
import iconDumper from '../../../assets/images/vehicle_icons/dumper-active-opti.png';
import iconDriller from '../../../assets/images/vehicle_icons/driller-active-opti.png';
import iconExcavator from '../../../assets/images/vehicle_icons/excavator-active-opti.png';
import iconGrader from '../../../assets/images/vehicle_icons/grader-active-opti.png';
import iconLoader from '../../../assets/images/vehicle_icons/loader-active-opti.png';
import iconMilling from '../../../assets/images/vehicle_icons/milling-active-opti.png';
import iconPiling from '../../../assets/images/vehicle_icons/piling-rig-active-opti.png';
import iconRoller from '../../../assets/images/vehicle_icons/roller-active-opti.png';
import iconRover from '../../../assets/images/vehicle_icons/rover-active-opti.png';
import iconSimulator from '../../../assets/images/vehicle_icons/simulator-active-opti.png';
import iconTandemRoller from '../../../assets/images/vehicle_icons/tandem-roller-active-opti.png';
import iconTotalstation from '../../../assets/images/vehicle_icons/total-station-active-opti.png';
import iconTractor from '../../../assets/images/vehicle_icons/tractor-active-opti.png';
import iconTruck from '../../../assets/images/vehicle_icons/truck-active-opti.png';
import iconTruckInactive from '../../../assets/images/vehicle_icons/truck-inactive-opti.png';
import iconTunnelrig from '../../../assets/images/vehicle_icons/tunnelrig-active-opti.png';
import iconUnknown from '../../../assets/images/vehicle_icons/unknown-active-opti.png';

//@ts-ignore
const removeDiacritics = require('diacritics').remove;

export type VehicleStatusColor = 'yellow' | 'red' | 'green' | 'grey';

export interface IVehiclesGrouped {
    active: IVehicle[];
    noPosition: IVehicle[];
    onHold: IVehicle[];
    otherProject: IVehicle[];
    totalCount: number;
}

const TYPES: {
    key: string;
    text: string;
    icon: string;
    iconGrayscale?: string;
}[] = [
    {
        key: 'UNKNOWN',
        text: 'Unknown',
        icon: iconUnknown,
        iconGrayscale: null,
    },
    {
        key: 'EXCAVATOR',
        text: kuura.getMessage('js_vehicletype.excavator'),
        icon: iconExcavator,
        iconGrayscale: null,
    },
    {
        key: 'LOADER',
        text: kuura.getMessage('js_vehicletype.loader'),
        icon: iconLoader,
        iconGrayscale: null,
    },
    {
        key: 'BULLDOZER',
        text: kuura.getMessage('js_vehicletype.bulldozer'),
        icon: iconBulldozer,
        iconGrayscale: null,
    },
    {
        key: 'BACKHOE',
        text: kuura.getMessage('js_vehicletype.backhoe'),
        icon: iconBackhoe,
        iconGrayscale: null,
    },
    {
        key: 'PILING',
        text: kuura.getMessage('js_vehicletype.piling'),
        icon: iconPiling,
        iconGrayscale: null,
    },
    {
        key: 'DUMPER',
        text: kuura.getMessage('js_vehicletype.dumper'),
        icon: iconDumper,
        iconGrayscale: null,
    },
    {
        key: 'GRADER',
        text: kuura.getMessage('js_vehicletype.grader'),
        icon: iconGrader,
        iconGrayscale: null,
    },
    {
        key: 'SIMULATOR',
        text: kuura.getMessage('js_vehicletype.simulator'),
        icon: iconSimulator,
        iconGrayscale: null,
    },
    {
        key: 'TRUCK',
        text: kuura.getMessage('js_vehicletype.truck'),
        icon: iconTruck,
        iconGrayscale: iconTruckInactive,
    },
    {
        key: 'ROVER',
        text: kuura.getMessage('js_vehicletype.rover'),
        icon: iconRover,
        iconGrayscale: null,
    },
    {
        key: 'DRILLER',
        text: kuura.getMessage('js_vehicletype.driller'),
        icon: iconDriller,
        iconGrayscale: null,
    },
    {
        key: 'BASESTATION',
        text: kuura.getMessage('js_vehicletype.basestation'),
        icon: iconBasestation,
        iconGrayscale: null,
    },
    {
        key: 'ROLLER',
        text: kuura.getMessage('js_vehicletype.roller'),
        icon: iconRoller,
        iconGrayscale: null,
    },
    {
        key: 'ASPHALT',
        text: kuura.getMessage('js_vehicletype.asphalt'),
        icon: iconAsphalt,
        iconGrayscale: null,
    },
    {
        key: 'TUNNELRIG',
        text: kuura.getMessage('js_vehicletype.tunnelrig'),
        icon: iconTunnelrig,
        iconGrayscale: null,
    },
    {
        key: 'BARGE',
        text: kuura.getMessage('js_vehicletype.barge'),
        icon: iconBarge,
        iconGrayscale: null,
    },
    {
        key: 'MILLING',
        text: kuura.getMessage('js_vehicletype.milling'),
        icon: iconMilling,
        iconGrayscale: null,
    },
    {
        key: 'TANDEM_ROLLER',
        text: kuura.getMessage('js_vehicletype.tandem_roller'),
        icon: iconTandemRoller,
        iconGrayscale: null,
    },
    {
        key: 'TOTALSTATION',
        text: kuura.getMessage('js_vehicletype.totalstation'),
        icon: iconTotalstation,
        iconGrayscale: null,
    },
    {
        key: 'TRACTOR',
        text: kuura.getMessage('js_vehicletype.tractor'),
        icon: iconTractor,
        iconGrayscale: null,
    },
];

const generateGrayscaleIcons = async () => {
    TYPES.forEach(async v => {
        if (v.icon && !v.iconGrayscale) {
            v.iconGrayscale = await CanvasUtils.toGrayscale(v.icon);
        }
    });
};
generateGrayscaleIcons();

const VENDORS = [
    { key: 'UNKNOWN', text: 'Unknown' },
    { key: 'NOVATRON', text: 'Novatron' },
    { key: 'PROLEC', text: 'Prolec' },
    { key: 'DIGPILOT', text: 'DigPilot' },
    { key: 'INFRAKIT', text: 'Infrakit' },
    { key: 'LEICA', text: 'Leica' },
    { key: 'TRIMBLE', text: 'Trimble' },
    { key: 'TOPCON', text: 'Topcon' },
    { key: 'SANDVIK', text: 'Sandvik' },
    { key: 'TECHBELAR', text: 'Techbelar' },
    { key: 'TRIMBLE_EARTHWORKS', text: 'Trimble Earthworks' },
    { key: 'CARLSON', text: 'Carlson' },
    { key: 'GEOMAX', text: 'Geomax' },
    { key: 'MAKIN3D', text: 'Makin 3D' },
    { key: 'ARPENGO', text: 'Arpengo' },
    { key: 'UNICONTROL', text: 'Unicontrol' },
    { key: 'TRIMBLE_GROUNDWORKS', text: 'Trimble Groundworks' },
    { key: 'MARXACT', text: 'marXact' },
    { key: 'DITIO', text: 'Ditio' },
    { key: 'MTS', text: 'Mts' },
    { key: 'FIELDSIGHT', text: 'Fieldsight' },
    { key: 'ROCKMA', text: 'Rockma' },
];

const TypesIndexedByKey = TYPES.reduce((obj, val, i) => {
    obj[val.key] = val;
    return obj;
}, {});

const VendorsIndexedByKey = VENDORS.reduce((obj, val, i) => {
    obj[val.key] = val;
    return obj;
}, {});

const VendorNames = VENDORS.map(v => v.text);

const VendorsIndexedOptions: { [key: number]: { title: string; value: string; active: boolean } } = VendorNames.reduce((obj, val, i) => {
    obj[i] = {
        title: val,
        value: i,
        active: true,
    };
    return obj;
}, {});

const TypeNames = TYPES.map(v => v.text);
const TypesIndexedOptions: { [key: number]: { title: string; value: string; active: boolean } } = TypeNames.reduce((obj, val, i) => {
    obj[i] = {
        title: val,
        value: i,
        active: true,
    };
    return obj;
}, {});

const powerSources = {
    0: kuura.getMessage('js_vehicles.power_source.unknown'),
    1: kuura.getMessage('js_vehicles.power_source.diesel'),
    2: kuura.getMessage('js_vehicles.power_source.petrol'),
    3: kuura.getMessage('js_vehicles.power_source.electric'),
    4: kuura.getMessage('js_vehicles.power_source.biodiesel'),
};

const emissionClasses = {
    0: kuura.getMessage('js_vehicles.power_source.unknown'),
    1: 'EURO 1',
    2: 'EURO 2',
    3: 'EURO 3',
    4: 'EURO 4',
    5: 'EURO 5',
    6: 'EURO 6',
    7: 'EURO 7',
    8: 'STAGE I',
    9: 'STAGE II',
    10: 'STAGE IIIA',
    11: 'STAGE IIIB',
    12: 'STAGE IV',
    13: 'STAGE V',
};

// sets additional fields on object that are needed later
function preProcessEntity(ajaxData: IVehicle): IVehicle {
    const v = Object.assign({}, ajaxData);

    v.vendorString = VendorNames[v.vendor]; // vendor int to string
    v.typeString = TypeNames[v.type]; // type int to string

    const warnings = getWarnings(v);

    v.calibWarningsMsgs = warnings.join('\x0A');
    v.calibWarningSigns = warnings.length > 1 ? '!!' : '!';

    v.nameLatin = removeDiacritics(v.name);
    return v;
}

function groupByStatus(vehicles: IVehicle[]): IVehiclesGrouped {
    const empty: IVehiclesGrouped = {
        active: [],
        noPosition: [],
        onHold: [],
        otherProject: [],
        totalCount: 0,
    };

    const grouped = _.groupBy(vehicles, v => {
        if (v.onHold) return 'onHold';
        if (v.activeProject && v.activeProject.id != kuura.getProjectId()) return 'otherProject';
        if (v.position && typeof v.position.latitude === 'number' && typeof v.position.longitude === 'number') return 'active';
        return 'noPosition';
    });

    return {
        ...empty,
        ...grouped,
        totalCount: vehicles.length,
    };
}

function getWarnings(vehicle: IVehicle, tolerance: number = 0.05) {
    const messages = [];

    // Calibration x/y/z difference [{0}/{1}/{2}] cm (vehicles.calibration_over)
    const diffs = vehicle.calibrationDifference;
    const diffWarning = diffs[0] != null && (diffs[0] > tolerance || diffs[1] > tolerance || diffs[2] > tolerance);
    if (diffWarning) {
        messages.push(kuura.getMessage('js_vehicles.calibration_difference', diffs[0], diffs[1], diffs[2]));
    }

    // Last calibration over 2 weeks ago ({0}) (vehicles.calibration_difference)
    if (vehicle.calibrationWarning) {
        messages.push(kuura.getMessage('js_vehicles.calibration_over', '-'));
    }

    return messages;
}

function getCalibrationStatus(vehicle: IVehicle): IVehicleCalibrationStatus {
    let tol = vehicle.accuracyTolerance;

    if (!tol || tol.enabled) {
        tol = vehicle.activeProject.accuracyTolerance ||
            kuura.getAccuracyTolerance() || {
                x: 0.05,
                y: 0.05,
                z: 0.05,
                enabled: true,
                source: 'PROJECT',
            };

        if (tol) {
            tol.source = 'PROJECT';
        }
    }

    if (!tol) {
        console.warn('No accuracy tolerance data found for vehicle: ', vehicle);
        return null;
    }

    const diffs = vehicle.calibrationDifference;
    if (diffs && diffs[0] != null) {
        const acc: IVehicleCalibrationStatus = {
            xValid: diffs[0] < tol.x,
            yValid: diffs[1] < tol.y,
            zValid: diffs[2] < tol.z,
            allDeltasValid: false,
            tol,
        };
        acc.allDeltasValid = acc.xValid && acc.yValid && acc.zValid;
        return acc;
    } else {
        return null;
    }
}

// returns all vehicles
export function fetchForActiveProject(): JQueryPromise<IVehicle[]> {
    return Ajax({
        url: 'api/1/project/' + kuura.getProjectId() + '/vehicles.json',
    }).then((resp: { vehicleList: IVehicle[] }) => {
        return resp.vehicleList.map(preProcessEntity);
    });
}

// returns vehicles with position
export function fetchWithPositions(projectId?: number): JQueryPromise<IVehicle[]> {
    let data = {};
    if ($.isNumeric(projectId)) {
        data = {
            projectId,
        };
    }
    return Ajax({
        url: 'api/ajax_vehicles.json',
        data,
    }).then((resp: { vehicles: IVehicle[] }) => {
        return resp.vehicles.map(preProcessEntity);
    });
}

function fetchAccuracyCounts(): JQueryPromise<{ [key: string]: number }> {
    return Ajax({
        url: 'vehicles/accuracy_counts.json',
    }).then(resp => resp.counts);
}

export function sendMessage(vehicleId: number, message: string): JQueryPromise<any> {
    return Ajax({
        url: 'ajax_new_vehicle_message.json',
        method: 'POST',
        data: {
            vehicleId,
            message,
        },
    });
}

export function deleteAccuracyLogpoints(vehicleId: number, accuracyLogpointId: number): JQueryPromise<any> {
    return Ajax({
        url: `vehicles/${vehicleId}/accuracy/${accuracyLogpointId}/delete`,
        method: 'post',
    });
}

export function getEfficiencyForWeek(week: Date): JQueryPromise<any> {
    return Ajax({
        url: 'ajax_vehicles_efficiency_for_weeks.json',
        data: {
            week,
        },
    });
}

export function getActivityCalendar(vehicleId: number, start: number, end: number): JQueryPromise<any> {
    return Ajax({
        url: 'ajax_calendar_events.json',
        data: {
            vehicleId,
            start,
            end,
        },
    });
}

export function getCalendarErrors(vehicleId: number, start: number, end: number): JQueryPromise<any> {
    return Ajax({
        url: 'ajax_calendar_error_number.json',
        data: {
            vehicleId,
            start,
            end,
        },
    });
}

export function getCalendarActiveModelEvents(vehicleId: number, start: number, end: number): JQueryPromise<any> {
    return Ajax({
        url: 'ajax_calendar_active_model_events.json',
        data: {
            vehicleId,
            start,
            end,
        },
    });
}

export function getCalendarActiveModelList(vehicleId: number, start: number, end: number): JQueryPromise<any> {
    return Ajax({
        url: 'ajax_active_models_list.json',
        data: {
            vehicleId,
            start,
            end,
        },
    });
}

export function getModelRights(vehicleId: number): JQueryPromise<any> {
    return Ajax({
        url: `vehicles/${vehicleId}/models`,
    });
}

export function setModelRights(vehicleId: number, modelIds: number[], linkIds: number[]): JQueryPromise<any> {
    const projectId: number = kuura.getProjectId();
    return Ajax({
        url: `vehicles/${vehicleId}/models`,
        method: 'post',
        data: {
            modelIds,
            linkIds,
            projectId,
        },
    });
}

export function copyModelRights(fromVehicleId: number, toVehicleIds: number[]): JQueryPromise<any> {
    const projectId: number = kuura.getProjectId();
    return Ajax({
        url: `vehicles/${fromVehicleId}/models/copy`,
        method: 'post',
        data: {
            fromVehicleId,
            toVehicleIds,
            projectId,
        },
    });
}

export function fetchEmissions(vehicleUuid: string): Promise<IVehicleEmission> {
    return Ajax2({
        url: `${kuura.getContextPath()}/api/1/vehicle/${vehicleUuid}/vehicle-emissions`,
    });
}

export function createOrUpdateEmissions(vehicleUuid: string, emission: Partial<IVehicleEmission>): Promise<IVehicleEmission> {
    return Ajax2({
        url: `${kuura.getContextPath()}/api/1/vehicle/${vehicleUuid}/vehicle-emissions`,
        method: 'post',
        contentType: 'json',
        data: emission,
    });
}

export const VehiclesService = {
    groupByStatus,
    getWarnings,
    fetchAccuracyCounts,
    fetchForActiveProject,
    fetchWithPositions,
    getCalibrationStatus,
    VENDORS,
    VendorNames,
    VendorsIndexedByKey,
    VendorsIndexedOptions,
    TYPES,
    TypeNames,
    TypesIndexedByKey,
    TypesIndexedOptions,
    sendMessage,
    getCalendarActiveModelEvents,
    getCalendarActiveModelList,
    getCalendarErrors,
    getActivityCalendar,
    getEfficiencyForWeek,
    deleteAccuracyLogpoints,
    fetchEmissions,
    createOrUpdateEmissions,
    powerSources,
    emissionClasses,
};
